import  { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Modal, Spinner } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt, FaUsers, FaPhone, FaEnvelope, FaBuilding, FaCheckCircle } from 'react-icons/fa';
import { bookingService } from '../../../services/booking.services';
import { colors } from '../../../utils/Colors';

const BookNow = () => {
    const [formData, setFormData] = useState({
        name: '',
        phoneNo: '',
        email: '',
        functionDate: null,
        time: '',
        guestCount: '',
        hall: '',
        menu: {
            menu1: '',
            menu2: '',
            menu3: ''
        }
    });
    
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [showAvailability, setShowAvailability] = useState(false);
    const [availableHalls, setAvailableHalls] = useState({
        lunch: { hall1: true, hall2: true },
        dinner: { hall1: true, hall2: true }
    });
    const [bookedHalls, setBookedHalls] = useState([]);
    const [showSuccessModal, setShowSuccessModal] = useState(false);


    const menuOptions = [
        'Traditional Mehndi Menu 1',
        'Traditional Mehndi Menu 2', 
        'Traditional Mehndi Menu 3',
        'Traditional Mehndi Menu 4',
        'Barat/Walima Menu 5',
        'Barat/Walima Menu 6',
        'Barat/Walima Menu 7',
        'Barat/Walima Menu 8',
        'RONAQ Special',
        'RONAQ Premium',
        'RONAQ Premium Ultimate',
        'Custom Menu'
    ];

   
    const checkAvailability = async () => {
        if (!formData.functionDate) {
            setError('Please select a date first');
            return;
        }

        try {
            setLoading(true);
            const dateStr = formData.functionDate.toISOString().split('T')[0];
            const response = await bookingService.checkHallAvailability(dateStr);
            
            setAvailableHalls(response.data.availability);
            setBookedHalls(response.data.bookedHalls);
            setShowAvailability(true);
            setError('');
        } catch (err) {
            setError(err.message || 'Error checking availability');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        if (name.startsWith('menu.')) {
            const menuField = name.split('.')[1];
            setFormData(prev => ({
                ...prev,
                menu: {
                    ...prev.menu,
                    [menuField]: value
                }
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleDateChange = (date) => {
        setFormData(prev => ({
            ...prev,
            functionDate: date
        }));
        setShowAvailability(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
       
        const errors = [];
        if (!formData.name.trim()) errors.push('Name is required');
        if (!formData.phoneNo.trim()) errors.push('Phone number is required');
        if (!formData.email.trim()) errors.push('Email is required');
        if (!formData.functionDate) errors.push('Function date is required');
        if (!formData.time) errors.push('Time slot is required');
        if (!formData.hall) errors.push('Hall selection is required');
        if (!formData.guestCount || formData.guestCount < 50) errors.push('Minimum 50 guests required');
        
        if (errors.length > 0) {
            setError(errors.join(', '));
            return;
        }

     
        if (formData.functionDate && formData.time && formData.hall) {
            if (!availableHalls[formData.time][formData.hall]) {
                setError('Selected hall is already booked for this time slot. Please select another hall or time.');
                return;
            }
        }

        setLoading(true);
        setError('');
        
        try {
            const bookingData = {
                ...formData,
                functionDate: formData.functionDate.toISOString()
            };
            
            const response = await bookingService.createBook(bookingData);
            
            if (response.success) {
                setSuccess(true);
                setShowSuccessModal(true);
              
                setFormData({
                    name: '',
                    phoneNo: '',
                    email: '',
                    functionDate: null,
                    time: '',
                    guestCount: '',
                    hall: '',
                    menu: {
                        menu1: '',
                        menu2: '',
                        menu3: ''
                    }
                });
                setShowAvailability(false);
            } else {
                setError(response.message || 'Failed to create booking');
            }
        } catch (err) {
            setError(err.message || 'Network error. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const HallAvailabilityCard = ({ hall, time }) => {
        const isAvailable = availableHalls[time][hall];
        const hallName = hall === 'hall1' ? 'Hall 1 ' : 'Hall 2 ';
        const timeLabel = time === 'lunch' ? '12:00 PM - 4:00 PM' : '7:00 PM - 11:00 PM';
        
        return (
            <Card className={`mb-3 ${isAvailable ? 'border-success' : 'border-danger'}`}>
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h6 className="fw-bold mb-1">{hallName}</h6>
                            <small className="text-muted">{timeLabel}</small>
                        </div>
                        <div>
                            {isAvailable ? (
                                <span className="badge bg-success px-3 py-2">
                                    <FaCheckCircle className="me-1" /> Available
                                </span>
                            ) : (
                                <span className="badge bg-danger px-3 py-2">
                                    Booked
                                </span>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        );
    };

    const SuccessModal = () => (
        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="text-success">
                    <FaCheckCircle className="me-2" />
                    Booking Request Submitted!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <div className="mb-4">
                        <div className="circle-check mb-3 mx-auto" style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '50%',
                            backgroundColor: '#d4edda',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <FaCheckCircle size={40} color="#28a745" />
                        </div>
                        <h4 className="fw-bold mb-3">Thank You!</h4>
                        <p className="text-muted">
                            Your booking request has been submitted successfully. 
                            Our team will contact you within 24 hours to confirm your booking.
                        </p>
                    </div>
                    
                    <div className="booking-details p-3 mb-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                        <p className="mb-2"><strong>Reference Number:</strong> {Math.random().toString(36).substr(2, 9).toUpperCase()}</p>
                        <p className="mb-0"><strong>Contact:</strong> 0315-5530667</p>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Button variant="success" onClick={() => setShowSuccessModal(false)}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );

    return (
        <div className="book-now-page py-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
            <Container>
                {/* Header */}
                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold mb-3" style={{ color: colors.PRIMARY }}>
                        Book Your Event at RONAQ Banquet
                    </h1>
                    <p className="lead text-muted mb-4">
                        Complete the form below to reserve your special occasion. We'll contact you for confirmation.
                    </p>
                </div>

                <Row>
                    {/* Booking Form */}
                    <Col lg={8} className="mb-4">
                        <Card className="border-0 shadow-lg">
                            <Card.Body className="p-4">
                                {success && !showSuccessModal && (
                                    <Alert variant="success" className="d-flex align-items-center">
                                        <FaCheckCircle className="me-2" />
                                        Booking request submitted successfully!
                                    </Alert>
                                )}
                                
                                {error && (
                                    <Alert variant="danger">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    {/* Personal Information */}
                                    <div className="mb-4">
                                        <h4 className="mb-3" style={{ color: colors.PRIMARY }}>
                                            <FaUsers className="me-2" />
                                            Personal Information
                                        </h4>
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Full Name <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        value={formData.name}
                                                        onChange={handleChange}
                                                        placeholder="Enter your full name"
                                                        required
                                                        disabled={loading}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Phone Number <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="phoneNo"
                                                        value={formData.phoneNo}
                                                        onChange={handleChange}
                                                        placeholder="03XX-XXXXXXX"
                                                        required
                                                        disabled={loading}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Email Address <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={formData.email}
                                                        onChange={handleChange}
                                                        placeholder="Enter your email"
                                                        required
                                                        disabled={loading}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Event Details */}
                                    <div className="mb-4">
                                        <h4 className="mb-3" style={{ color: colors.PRIMARY }}>
                                            <FaCalendarAlt className="me-2" />
                                            Event Details
                                        </h4>
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Function Date <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <DatePicker
                                                        selected={formData.functionDate}
                                                        onChange={handleDateChange}
                                                        className="form-control"
                                                        placeholderText="Select date"
                                                        minDate={new Date()}
                                                        dateFormat="dd/MM/yyyy"
                                                        disabled={loading}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Number of Guests <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="guestCount"
                                                        value={formData.guestCount}
                                                        onChange={handleChange}
                                                        placeholder="Approximate number of guests"
                                                        min="50"
                                                        max="1000"
                                                        required
                                                        disabled={loading}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        Minimum 50 guests required
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Time Slot <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="time"
                                                        value={formData.time}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={loading}
                                                    >
                                                        <option value="">Select Time</option>
                                                        <option value="lunch">Lunch (12:00 PM - 4:00 PM)</option>
                                                        <option value="dinner">Dinner (7:00 PM - 11:00 PM)</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label className="fw-bold">
                                                        Select Hall <span className="text-danger">*</span>
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="hall"
                                                        value={formData.hall}
                                                        onChange={handleChange}
                                                        required
                                                        disabled={loading || !formData.time}
                                                    >
                                                        <option value="">Select Hall</option>
                                                        <option value="hall1" disabled={!availableHalls[formData.time]?.hall1}>
                                                            Hall 1 
                                                        </option>
                                                        <option value="hall2" disabled={!availableHalls[formData.time]?.hall2}>
                                                            Hall 2 
                                                        </option>
                                                        <option 
                                                            value="both" 
                                                            disabled={!availableHalls[formData.time]?.hall1 || !availableHalls[formData.time]?.hall2}
                                                        >
                                                            Both Halls 
                                                        </option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        
                                        {/* Check Availability Button */}
                                        <div className="mb-4">
                                            <Button
                                                variant="outline-primary"
                                                onClick={checkAvailability}
                                                disabled={!formData.functionDate || loading}
                                                className="w-100 py-2"
                                            >
                                                {loading ? (
                                                    <>
                                                        <Spinner size="sm" className="me-2" />
                                                        Checking Availability...
                                                    </>
                                                ) : (
                                                    'Check Hall Availability'
                                                )}
                                            </Button>
                                        </div>
                                    </div>

                                    {/* Menu Selection */}
                                    <div className="mb-4">
                                        <h4 className="mb-3" style={{ color: colors.PRIMARY }}>
                                            Menu Selection (Optional)
                                        </h4>
                                        <p className="text-muted mb-3">
                                            Select up to 3 preferred menus. Our team will discuss the best options with you.
                                        </p>
                                        <Row>
                                            <Col md={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>Preferred Menu 1</Form.Label>
                                                    <Form.Select
                                                        name="menu.menu1"
                                                        value={formData.menu.menu1}
                                                        onChange={handleChange}
                                                        disabled={loading}
                                                    >
                                                        <option value="">Select Menu</option>
                                                        {menuOptions.map((menu, index) => (
                                                            <option key={index} value={menu}>{menu}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>Preferred Menu 2</Form.Label>
                                                    <Form.Select
                                                        name="menu.menu2"
                                                        value={formData.menu.menu2}
                                                        onChange={handleChange}
                                                        disabled={loading}
                                                    >
                                                        <option value="">Select Menu</option>
                                                        {menuOptions.map((menu, index) => (
                                                            <option key={index} value={menu}>{menu}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>Preferred Menu 3</Form.Label>
                                                    <Form.Select
                                                        name="menu.menu3"
                                                        value={formData.menu.menu3}
                                                        onChange={handleChange}
                                                        disabled={loading}
                                                    >
                                                        <option value="">Select Menu</option>
                                                        {menuOptions.map((menu, index) => (
                                                            <option key={index} value={menu}>{menu}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </div>

                                  
                                    <div className="text-center pt-3">
                                        <Button
                                            variant="warning"
                                            type="submit"
                                            size="lg"
                                            className="px-5 py-2 fw-bold"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <Spinner size="sm" className="me-2" />
                                                    Submitting...
                                                </>
                                            ) : (
                                                'Submit Booking Request'
                                            )}
                                        </Button>
                                        <p className="text-muted mt-3 small">
                                            By submitting, you agree to our terms and conditions
                                        </p>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>

                
                    <Col lg={4}>
                      
                        {showAvailability && formData.functionDate && (
                            <Card className="border-0 shadow-sm mb-4">
                                <Card.Header className="bg-primary text-white">
                                    <h5 className="mb-0">
                                        <FaCalendarAlt className="me-2" />
                                        Availability for {formData.functionDate.toLocaleDateString('en-PK')}
                                    </h5>
                                </Card.Header>
                                <Card.Body>
                                    <h6 className="mb-3">Lunch (12:00 PM - 4:00 PM)</h6>
                                    <HallAvailabilityCard hall="hall1" time="lunch" />
                                    <HallAvailabilityCard hall="hall2" time="lunch" />
                                    
                                    <h6 className="mb-3 mt-4">Dinner (7:00 PM - 11:00 PM)</h6>
                                    <HallAvailabilityCard hall="hall1" time="dinner" />
                                    <HallAvailabilityCard hall="hall2" time="dinner" />
                                    
                                   
                                </Card.Body>
                            </Card>
                        )}

                        {/* Contact Information */}
                        <Card className="border-0 shadow-sm mb-4">
                            <Card.Header className="bg-primary text-white">
                                <h5 className="mb-0">Need Help?</h5>
                            </Card.Header>
                            <Card.Body>
                                <div className="mb-3">
                                    <h6 className="fw-bold mb-2">
                                        <FaPhone className="me-2" />
                                        Call Us
                                    </h6>
                                    <p className="mb-1">Manager: 0315-5530667</p>
                                    <p className="mb-0">Support: 0332-9911223</p>
                                </div>
                                
                                {/* <div className="mb-3">
                                    <h6 className="fw-bold mb-2">
                                        <FaEnvelope className="me-2" />
                                        Email Us
                                    </h6>
                                    <p className="mb-0">bookings@ronaqmarquee.com</p>
                                </div> */}
                                
                                <div className="mb-3">
                                    <h6 className="fw-bold mb-2">
                                        <FaBuilding className="me-2" />
                                        Visit Us
                                    </h6>
                                    <p className="mb-0 small">
                                        Main NUST Double Road, OPP. Gate # H13, Islamabad
                                    </p>
                                </div>
                            </Card.Body>
                        </Card>

                    
                        <Card className="border-0 shadow-sm">
                            <Card.Header className="bg-primary text-white">
                                <h5 className="mb-0">Important Information</h5>
                            </Card.Header>
                            <Card.Body>
                                <ul className="list-unstyled mb-0">
                                    <li className="mb-2">
                                        <strong>Advance Payment:</strong>
                                        <p className="mb-0 small text-muted">
                                            25% advance required to confirm booking
                                        </p>
                                    </li>
                                    <li className="mb-2">
                                        <strong>Cancellation Policy:</strong>
                                        <p className="mb-0 small text-muted">
                                            30+ days: 80% refund<br />
                                            15-30 days: 50% refund<br />
                                            Less than 15 days: No refund
                                        </p>
                                    </li>
                                    <li className="mb-2">
                                        <strong>Booking Process:</strong>
                                        <p className="mb-0 small text-muted">
                                            1. Submit request<br />
                                            2. We contact you<br />
                                            3. Confirm with advance
                                        </p>
                                    </li>
                                    <li>
                                        <strong>Timing:</strong>
                                        <p className="mb-0 small text-muted">
                                            Lunch: 12:00 PM - 4:00 PM<br />
                                            Dinner: 7:00 PM - 11:00 PM
                                        </p>
                                    </li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <SuccessModal />

            <style jsx="true">{`
                .book-now-page {
                    min-height: 100vh;
                }
                
                .circle-check {
                    animation: pulse 2s infinite;
                }
                
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                
                .card {
                    transition: all 0.3s ease;
                    border-radius: 15px;
                }
                
                .card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 10px 25px rgba(0,0,0,0.1) !important;
                }
                
                @media (max-width: 768px) {
                    .display-5 {
                        font-size: 2.2rem;
                    }
                    
                    .lead {
                        font-size: 1.1rem;
                    }
                }
            `}</style>
        </div>
    );
};

export default BookNow;